import styled from 'styled-components'
import { Copy } from '@stokr/components-library'
import { Fireworks } from 'components/ui/fireworks/Fireworks'
import type { RedemptionCompletedView } from 'hooks/sto/redemptionCompleted'
import { stoColor, stoSpace, stoType } from 'constants/stoTheme'

/** Figma "Redemption completed": the single tab-like heading. */
const Heading = styled.h2`
  ${stoType.tabLabel};
  margin: 0;
  text-transform: none;
  padding: ${stoSpace[4]} ${stoSpace[8]};
  text-align: center;
  color: ${stoColor.textPrimary};
`

const Body = styled.div`
  position: relative;
  isolation: isolate;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${stoSpace[8]};
  padding: 24px 24px ${stoSpace[12]};
`

/** Above the fireworks. */
const Figure = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${stoSpace[1]};
  width: 100%;
  text-align: center;
`

const FigureLabel = styled.p`
  ${stoType.columnLabel};
  margin: 0;
  color: ${stoColor.textSecondary};
`

const FigureValue = styled.p`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 1.5px;
  color: ${stoColor.textPrimary};
`

interface RedemptionCompletedProps extends RedemptionCompletedView {
  /** Off while the card is out of sight; the show plays each time it turns on. */
  celebrate: boolean
}

/** Figma 3041:28642: replaces the Invest/Trade/Redeem tabs once the product is fully redeemed. */
export const RedemptionCompleted = ({ symbol, payout, celebrate }: RedemptionCompletedProps) => (
  <>
    <Heading>
      <Copy id="stoPage.keyActions.completed.title" />
    </Heading>
    <Body>
      {payout && (
        <Figure>
          <FigureLabel>
            {symbol ? (
              <Copy id="stoPage.keyActions.completed.payout" values={{ symbol }} />
            ) : (
              <Copy id="stoPage.keyActions.completed.payoutFallback" />
            )}
          </FigureLabel>
          <FigureValue>{payout}</FigureValue>
        </Figure>
      )}
      {celebrate && <Fireworks />}
    </Body>
  </>
)
